
// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('product.pricelists', {
        url: '/pricelists',
        views: {'productList@product': {
            templateUrl: 'main/product/pricelists/pricelists.tpl.html',
            controller: 'PricelistsController as vm'
        }},
        resolve: {
            pricelists: pricelistsResolver
        }
    });
}

// @ngInject
function pricelistsResolver(PricelistsApiService) {
    return PricelistsApiService.getPricelistBriefs();
}

// @ngInject
function PricelistsController($rootScope, $state, $scope, pricelists, PricelistsApiService,loadSpinnerService) {
    var vm = this;

    vm.currentUser = $rootScope.currentUser;

    vm.pricelists = pricelists.results;
    vm.selectedPricelistId = 0;
    vm.searchTerm = "";
    vm.currentPage = 1;
    vm.itemsPerPage = 20;

    vm.searchTermChange = searchTermChange;

    activate();

    function activate() {
        $scope.$watch(function() { return $state.params.pricelistId; }, function(newValue, oldValue) {
            vm.selectedPricelistId = parseInt($state.params.pricelistId, 10);
        });
        $rootScope.$on('Pricelist.Inserted', function(event, response) {
            loadPricelists();
        });
        $rootScope.$on('Pricelist.Changed', function(event, response) {
            loadPricelists();
        });
    }

    function loadPricelists() {
        loadSpinnerService.start('mainSpinner');
        PricelistsApiService.getPricelistBriefs().then(function(response) {
            vm.pricelists = response.results;
        }).finally(function () {
            loadSpinnerService.stop('mainSpinner',{force: true});
        });
    }

    function searchTermChange() {
        vm.currentPage = 1;
        loadPricelists();
    }

}

angular
    .module('product.pricelists', ['pricelists.api','pricelists.pricelist'])
    .config(stateConfig)
    .controller('PricelistsController', PricelistsController);
